import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ProfileService } from "./profile.service";

declare let clevertap;

@Injectable()
export class ClevertapEventsService {
  // constructor(private profileService: ProfileService) {}

  public static emitEvent(type: string, data: Object = {}) {
    if (!environment["test"]) {
      console.log("Clevertap event", type, data);
      clevertap.event.push(type, data);
    }
  }

  public static emitLogin(user: Object) {
    const userData: any = user || JSON.parse(localStorage.getItem("userData"));
    const profile: any = {};

    if (userData["name"]) {
      profile["Name"] =
        userData["name"] +
        (userData["surname"] ? " " + userData["surname"] : "");
      profile["Firstname"] = userData["name"];
    }
    if (userData["surname"]) {
      profile["Surname"] = userData["surname"];
    }
    if (userData["email"]) {
      profile["Email"] = userData["email"];
    }

    if (userData["role"]) {
      profile["Role"] = userData["role"];
    }

    if (userData["Teams"] && userData["Teams"].length > 0) {
      profile.TeamsId = userData["Teams"][0].id;
      profile.TeamsName = userData["Teams"][0].name;
      profile.EmployersId = userData["Teams"][0].employers_id;
    }

    if (userData["id"]) {
      profile["Identity"] = userData["id"];
    }

    // FIX-ME add employer name

    profile["EmployerName"] = userData.employer.name;

    // FIX-ME add flags

    // profile['feature_flags'] =

    //clevertap.profile.push({ Site: profile });
    console.log('profile', profile);
    clevertap.onUserLogin.push({ Site: profile });
  }

  public static logout() {
    // this snippet should be invoked when a user logs out from your website
    clevertap.logout();
  }
}
